<template>
    <div>
        <purchase-details :title="language_terms['PURCHASE_INVOICE']" type="PI"></purchase-details>
    </div>
</template>
<script>
import { mapState } from "vuex";
import purchaseDetails from './details.vue'

export default {
    components: { purchaseDetails },
    computed:{
    ...mapState({
        language_terms: state => state.languages.language_terms,
      }),
    }
}
</script>
